// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1HH_v","col":"Table_col__2ziTO","fulfillmentStatus":"Table_fulfillmentStatus__2Dwma","emailCol":"Table_emailCol__1_asE"};